module.exports = __webpack_public_path__ + "static/img/banner_solutions_precision.b8a6eee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_precision.png
// module id = jOnL
// module chunks = 10